import { render, staticRenderFns } from "./overAverage.vue?vue&type=template&id=d957599e&scoped=true"
import script from "./overAverage.vue?vue&type=script&lang=js"
export * from "./overAverage.vue?vue&type=script&lang=js"
import style0 from "./overAverage.vue?vue&type=style&index=0&id=d957599e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d957599e",
  null
  
)

export default component.exports